import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const StyledDialog = styled(Dialog)`
  min-width: ${(props) => props.width || 'auto'};
  .MuiPaper-root {
    margin: 16px;
    border-radius: 16px;
  }

  .dialog-wrapper {
    border-radius: 16px;
    display: flex;
    gap: 22px;
    padding: ${(props) => (props.dialogDevice ? '16px' : '23px 30px')};
  }
  .MuiPaper-root {
    border-radius: ${(props) => props.dialogDevice && '16px'};
  }
  .content-wrapper {
    flex: 1;
    width: ${(props) => props.dialogDevice && '566px'};
  }

  .dialog-title {
    font-weight: 500;
    padding: 0;
    color: ${COLOR.dark};
    display: flex;
    gap: 8px;
    /* use these two below attributes to handle case not show icon (hiddenIcon is true) */
    margin-top: -5px;
    margin-bottom: 0px;
    /*  */
  }

  .title {
    color: ${COLOR.darkGray};
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: -0.4px;
  }

  .close-icon {
    float: right;
    margin-left: auto;
    padding: 5px 0px;
  }

  .description {
    font-size: 14px;
  }

  .dialog-content {
    padding: ${(props) => (props.dialogDevice ? '20px 0px' : '20px 4px')};
  }

  button {
    text-transform: unset;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    button {
      padding: 5px 10px;
    }
    .dialog-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 10px;
      padding: 20px;
    }
    .dialog-title {
      text-align: center;
      .MuiTypography-root {
        text-align: ${(props) => props.dialogDevice && 'left'};
      }
    }
    .title {
      font-size: 16px;
    }

    .content-wrapper {
      flex: 1;
      width: auto;
    }
    .MuiDialog-container {
      width: ${(props) => props.dialogDevice && '100%'};
    }
    .dialog-content {
      padding: 5px 4px;
      width: ${(props) => props.dialogDevice && '100%'};
      display: ${(props) => props.dialogDevice && 'flex'};
      justify-content: ${(props) => props.dialogDevice && 'center'};
    }

    .dialog-action {
      justify-content: center;
      align-items: center;
      gap: 10px;
      padding: ${(props) => props.removePaddingAction && '0px'};
    }

    .dialog-action > * {
      width: 100%;
    }
  }
`;
export { StyledDialog };
